// @ts-nocheck
// The team lead's action centre: one chip per exception the live feed can
// actually prove (break overrun, low connect rate, no active profile).
// Renders nothing when the floor is clean.
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { HAIRLINE, TONE } from './teamUi';

export default function TeamAlertsBar({ alerts, onPick }) {
  if (!alerts?.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-2xl border bg-card p-3 shadow-sm ${HAIRLINE}`}>
      <span className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.11em] text-destructive">
        <AlertTriangle size={13} />
        Attention required
      </span>
      {alerts.map((a) => (
        <button
          key={a.key}
          type="button"
          title={a.who.map((w) => w.name).join(', ')}
          onClick={onPick ? () => onPick(a) : undefined}
          className={`inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-[11px] font-medium transition-opacity hover:opacity-80 ${TONE[a.tone].soft} ${TONE[a.tone].text}`}
        >
          <span className="font-semibold tabular-nums">{a.n}</span>
          {a.n === 1 ? 'agent' : 'agents'} {a.text}
        </button>
      ))}
    </div>
  );
}
